import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { defaultGridData } from '../../../module/component/TableBoxModule';
import { PATH_DELIMITER, SEMESTER_STUDENT_ENROLMENT_CHECK_PATH } from '../../../constant/Constant';
import { request } from '../../ApiModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { SET_GRID_DATA } from '../../component/TableBoxModule';

const TAB_NO = 'TAB1';

const ACTION_SEARCH =
    SEMESTER_STUDENT_ENROLMENT_CHECK_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_EDIT = SEMESTER_STUDENT_ENROLMENT_CHECK_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'ACTION_EDIT';
const ACTION_EDIT_ENROLMENT_VALID_STATUS_CD =
    SEMESTER_STUDENT_ENROLMENT_CHECK_PATH +
    PATH_DELIMITER +
    TAB_NO +
    PATH_DELIMITER +
    'ACTION_EDIT_ENROLMENT_VALID_STATUS_CD';
const ACTION_EXCEL_DOWNLOAD =
    SEMESTER_STUDENT_ENROLMENT_CHECK_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'ACTION_EXCEL_DOWNLOAD';
const ACTION_EXCEL_UPLOAD =
    SEMESTER_STUDENT_ENROLMENT_CHECK_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'ACTION_EXCEL_UPLOAD';
const HANDLE_GRID_DATA =
    SEMESTER_STUDENT_ENROLMENT_CHECK_PATH + PATH_DELIMITER + TAB_NO + PATH_DELIMITER + 'HANDLE_GRID_DATA';

export const actionSearch = createAction(ACTION_SEARCH);
export const actionEdit = createAction(ACTION_EDIT);
export const actionEditEnrolmentValidStatusCd = createAction(ACTION_EDIT_ENROLMENT_VALID_STATUS_CD);
export const actionExcelDownload = createAction(ACTION_EXCEL_DOWNLOAD);
export const actionExcelUpload = createAction(ACTION_EXCEL_UPLOAD);

export function* semesterStudentEnrolmentCheckViewTab1BodySagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_EDIT, actionEditSaga);
    yield takeEvery(ACTION_EDIT_ENROLMENT_VALID_STATUS_CD, actionEditEnrolmentValidStatusCdSaga);
    yield takeEvery(ACTION_EXCEL_DOWNLOAD, actionExcelDownloadSaga);
    yield takeEvery(ACTION_EXCEL_UPLOAD, actionExcelUploadSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/semester-user/semesters/${params.semesterId}/users`,
        params,
        callback,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}

function* actionEditSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'put',
        url: `/api/semester-user/semesters/${data.semesterId}/users/${data.userId}`,
        data,
        callback,
    });
}

function* actionEditEnrolmentValidStatusCdSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'put',
        url: `/api/semester-user/semesters/${data.semesterId}/users/${data.userId}/staff-approve`,
        data,
        callback,
    });
}

function* actionExcelDownloadSaga({ payload: { params } }) {
    yield call(request, {
        method: 'get',
        url: `/api/semester-user/semesters/${params.semesterId}/users-excel-export`,
        params,
        download: true,
        downloadDirect: true,
        downloadType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
}

function* actionExcelUploadSaga({ payload: { params, callback, uploadProgress } }) {
    const formData = new FormData();
    formData.append('file', params.file);
    yield call(request, {
        method: 'post',
        url: `/api/semester-user/semesters/${params.semesterId}/users-excel-import`,
        data: formData,
        upload: true,
        uploadProgress,
        callback,
    });
}

const initialState = {
    gridData: defaultGridData,
};

const module = handleActions(
    {
        [HANDLE_GRID_DATA]: (state, { payload: gridData }) => ({ ...state, gridData }),
    },
    initialState,
);

export default module;
